import React, {Component,PropTypes} from 'react';
import cx from 'classnames';
import $ from 'jquery';

class Collapsible extends Component {

    static propTypes = {
        /**
         * There are two ways a collapsible can behave. It can either allow multiple sections to stay open,
         * or it can only allow one section to stay open at a time, which is called an accordion.
         * @default false
         */
        accordion: PropTypes.bool,
        /**
         * Enable popout style
         */
        popout: PropTypes.bool,
        defaultActiveKey: PropTypes.number,
        onSelect: PropTypes.func,
        /**
         * Set to true to disable the jQuery animations
         */
        noJQuery: PropTypes.bool,

        className: PropTypes.string,
        children: PropTypes.node
    };

    static defaultProps = {
        accordion: false,
        noJQuery: true
    };

    constructor(props) {
        super(props);
        this.renderItem = this.renderItem.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.state = {
            activeKey: props.defaultActiveKey
        };
    }

    initCollapsible(accordion) {
        if (typeof $ !== 'undefined') {
            setTimeout(()=>{
                $(this.refs.el).collapsible({
                    accordion
                });
            }, 0);
        }
    }

    renderItem(child, index) {
        let props = {
            key: child.key ? child.key : index,
            ref: child.ref
        };
        if (this.props.accordion) {
            props.expanded = child.props.eventKey === this.state.activeKey;
            props.onSelect = this.handleSelect;
        }
        if (!this.props.noJQuery){
            props.expanded = true;
        }
        return React.cloneElement(child, props);
    }

    handleSelect(key) {
        if (this.props.onSelect) {
            this.props.onSelect(key);
        }

        if (this.state.activeKey === key) {
            key = null;
        }
        this.setState({
            activeKey: key
        });
    }

    render() {
        let {
            accordion, popout, className, children, noJQuery, ...props
            } = this.props;
        let classes = {
            collapsible: true,
            popout
        };
        let collapsible = accordion ? 'accordion' : 'expandable';

        if (!noJQuery) {
            this.initCollapsible(!!accordion);
        }

        return (
            <ul className={cx(className, classes)} {...props} data-collapsible={collapsible} ref="el">
                {React.Children.map(children, this.renderItem)}
            </ul>
        );
    }
}

export default Collapsible;